import styled, {css} from 'styled-components';

import BaseClockIcon from '@edna/icons/clock.svg';

import {Button as BaseButton} from '../Button';
import {Dropdown as BaseDropdown, Overlay as BaseOverlay} from '../Dropdown';
import BaseTextInput from '../TextInput';
import {mixins} from '../styles';
import {DEFAULT_WIDTH, OPTION_HEIGHT, TTimePickerType} from './types';

type TClockIconProps = {
  disabled?: boolean;
};

export const ClockIcon = styled(BaseClockIcon)<TClockIconProps>`
  ${mixins.wh('16px')}
  ${({theme, disabled}) =>
    disabled &&
    css`
      color: ${theme.branding.colors.disabled};
    `}
`;

export const TextInput = styled(BaseTextInput)<{type: TTimePickerType}>`
  width: ${({type}) => DEFAULT_WIDTH[type]};
  min-width: ${({type}) => DEFAULT_WIDTH[type]};
`;

export const Overlay = styled(BaseOverlay)`
  box-shadow: ${({theme}) => theme.boxShadow.XS};
  border-radius: ${({theme}) => theme.borderRadius.br2};
`;

export const Wrapper = styled.div`
  ${mixins.stack({justify: 'end'})};
  padding: ${({theme: {spacing}}) => `${spacing.s3} ${spacing.s2} ${spacing.s3} ${spacing.s3}`};
`;

export const TimeColumn = styled.div`
  ${mixins.stack({justify: 'space-between'})};
  ${mixins.scroll({isVisibleOnHover: true})};
  max-height: ${OPTION_HEIGHT * 6}px;
  overflow: hidden auto;
`;

export const TimeSlot = styled.div<{disabled?: boolean}>`
  width: 100%;
  ${mixins.wh(`${OPTION_HEIGHT}px`)};
  min-width: ${OPTION_HEIGHT}px;
  min-height: ${OPTION_HEIGHT}px;
  ${mixins.stack({align: 'center', justify: 'center'})};
  ${mixins.f3};
  line-height: 16px;
  font-weight: 400;
  cursor: pointer;
  pointer-events: ${({disabled}) => (disabled ? 'none' : 'auto')};
  color: ${({disabled, theme}) =>
    disabled ? theme.branding.colors.disabled : theme.palette.grey900};
`;

export const TimeSlotStatus = styled.div<{isSelected?: boolean}>`
  ${mixins.round('32px')};
  ${mixins.stack({align: 'center', justify: 'center'})};
  transition: all ${({theme}) => theme.animation.duration / 2}ms;

  ${({isSelected, theme}) =>
    isSelected
      ? css`
          background-color: ${theme.branding.content.primary};
          border: 2px solid ${theme.palette.grey100};
          color: ${theme.palette.white};
        `
      : css`
          &:hover {
            background-color: ${theme.palette.grey50};
          }
        `}
`;

export const TimeHeader = styled.div`
  ${mixins.wh('40px', '20px')};
  min-width: 40px;
  min-height: 20px;
  ${mixins.stack({align: 'end', justify: 'center'})};
  ${mixins.f2};
  font-weight: 400;
  color: ${({theme}) => theme.palette.grey400};
  padding-right: ${({theme}) => theme.spacing.s1};
`;

export const Button = styled(BaseButton)`
  margin-top: 10px;
`;

export const Dropdown = styled(BaseDropdown)`
  width: fit-content;
`;
